import { memo } from 'react';

import type {
  NetworkGraphEdgeModel,
  NetworkGraphNodeModel,
} from '../NetworkGraph';
import { NetworkGraphEdge } from '../NetworkGraphEdge';
import type { NetworkGraphPosition } from '../utils/computeRadialLayout';

export interface NetworkGraphRenderableEdge {
  edge: NetworkGraphEdgeModel;
  source: NetworkGraphNodeModel;
  sourcePosition: NetworkGraphPosition;
  target: NetworkGraphNodeModel;
  targetPosition: NetworkGraphPosition;
}

export interface NetworkGraphEdgeLayerProps {
  renderableEdges: readonly NetworkGraphRenderableEdge[];
  laneOffsets: ReadonlyMap<string, number>;
  targetAngleOffsets: ReadonlyMap<string, number>;
  highlightedEdgeId?: string | null;
  onEdgeClick?: (edgeId: string) => void;
  onEdgeHover: (edgeId: string, hovered: boolean) => void;
  suppressAfterDrag: (fn: () => void) => () => void;
}

const NetworkGraphEdgeLayerComponent = ({
  renderableEdges,
  laneOffsets,
  targetAngleOffsets,
  highlightedEdgeId,
  onEdgeClick,
  onEdgeHover,
  suppressAfterDrag,
}: NetworkGraphEdgeLayerProps) => (
  <>
    {renderableEdges.map(({ edge, source, target, ...rest }) => (
      <NetworkGraphEdge
        edge={edge}
        isHovered={edge.id === highlightedEdgeId}
        key={edge.id}
        lateralOffset={laneOffsets.get(edge.id)}
        onClick={
          onEdgeClick
            ? suppressAfterDrag(() => onEdgeClick(edge.id))
            : undefined
        }
        onHover={hovered => onEdgeHover(edge.id, hovered)}
        source={source}
        target={target}
        targetAngleOffset={targetAngleOffsets.get(edge.id)}
        {...rest}
      />
    ))}
  </>
);

export const NetworkGraphEdgeLayer = memo(NetworkGraphEdgeLayerComponent);
